import React, { useState } from 'react';
import Pagination from '../../../common/Pagination';
import ReputationIcon from '../subparts/ReputationIcon';
import { REPUTATION_SECTION_THEMES, getReputationAvatarTheme } from '../subparts/reputationTheme';
import {
    formatReputationDate,
    getFeedbackMeta,
    getNameInitials,
} from '../subparts/reputationQuery';

function FeedbackTab({ patientFeedbacks, onPageChange }) {
    const [currentPage, setCurrentPage] = useState(0);
    const feedbacks = patientFeedbacks?.content || [];
    const totalElements = patientFeedbacks?.totalElements ?? 0;

    const handlePageChange = (page) => {
        setCurrentPage(page);
        onPageChange(page);
    };

    return (
        <div>
            <div className="reputation-section">
                <div className="reputation-section__heading">
                    <ReputationIcon icon="bi-emoji-smile" theme={REPUTATION_SECTION_THEMES.feedback} size="md" />
                    <div>
                        <h2 className="reputation-section__title">Patient Feedback</h2>
                        <p className="reputation-section__subtitle">
                            Sentiment feedback collected from your reputation page
                        </p>
                    </div>
                </div>
                <div className="reputation-section__actions">
                    <span className="reputation-chip">
                        <ReputationIcon icon="bi-emoji-smile" theme="success" size="xs" />
                        {totalElements} response{totalElements === 1 ? '' : 's'}
                    </span>
                </div>
            </div>

            {feedbacks.length > 0 ? (
                <>
                    <div className="table-responsive reputation-table-wrap">
                        <table className="table table-striped table-hover align-middle mb-0">
                            <thead>
                                <tr>
                                    <th>Patient</th>
                                    <th>Feedback</th>
                                    <th>Date</th>
                                </tr>
                            </thead>
                            <tbody>
                                {feedbacks.map((feedback, index) => {
                                    const feedbackMeta = getFeedbackMeta(feedback.feedback);

                                    return (
                                        <tr key={feedback.id}>
                                            <td>
                                                <div className="d-flex align-items-center gap-3">
                                                    <ReputationIcon
                                                        round
                                                        theme={getReputationAvatarTheme(feedback.id, index)}
                                                        size="md"
                                                        className="reputation-avatar"
                                                    >
                                                        {getNameInitials(feedback.patientName)}
                                                    </ReputationIcon>
                                                    <div>
                                                        <div className="fw-semibold text-dark">{feedback.patientName}</div>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <span className={feedbackMeta.className}>
                                                    <i className={`bi ${feedbackMeta.icon}`}></i>
                                                    {feedbackMeta.label}
                                                </span>
                                            </td>
                                            <td className="text-muted small">
                                                {formatReputationDate(feedback.createdAt)}
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>

                    {patientFeedbacks.totalPages > 1 && (
                        <div className="ecx-page-pagination border-top pt-3 mt-3">
                            <Pagination
                                currentPage={currentPage}
                                totalPages={patientFeedbacks.totalPages}
                                onPageChange={handlePageChange}
                                totalElements={totalElements}
                                pageSize={patientFeedbacks.pageable?.pageSize || 10}
                            />
                        </div>
                    )}
                </>
            ) : (
                <div className="ecx-page-empty">
                    <ReputationIcon
                        icon="bi-emoji-smile"
                        theme={REPUTATION_SECTION_THEMES.feedback}
                        size="lg"
                        className="reputation-empty-icon"
                    />
                    <h3 className="h6 fw-bold text-dark mb-1">No patient feedback</h3>
                    <p className="mb-0 small">Patient feedback will appear here once reviews are submitted.</p>
                </div>
            )}
        </div>
    );
}

export default FeedbackTab;
